export const redirectLink = 'redirectLink';
